
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Der Bettpartner oder die Bettpartnerin bemerkt diese Art von Schlafstörung oft als Erstes. Dabei handelt es sich um Bewegungsstörungen im Schlaf. Die Schlafart, aus der die Störung hervorgeht, ist für die Diagnosestellung wichtig und muss im Schlaflabor untersucht werden. Es gibt zwei Grundzustände des Schlafs. REM-Schlaf und Non-REM-Schlaf. REM steht für «Rapid Eye Movement» – die Augen bewegen sich hinter den geschlossenen Lidern. REM-Schlaf ist oft mit Träumen verbunden. In einigen Fällen werden Träume ausagiert, da die Muskulatur nicht vollständig entspannt werden kann. Oder es kommt zu einem partiellen Erwachen. Der Bewegungsapparat ist auf Wach eingestellt, der Rest des Gehirns ist noch im Schlafmodus. So können Schlafende aufstehen und komplexe Handlungen vornehmen. Es gibt Fälle mit Verletzungen des Schläfers oder des Bettpartners.`}</p>
    <Link href={'https://www.' + window.mandant + '.ch/zuerich/bellevue/und-wie-haben-sie-geschlafen/story/27400944'} icon='caret right' style={{
      fontSize: '16px'
    }} mdxType="Link">Sie sucht nach Fehlern im Schlaf
    </Link>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;